/**
 * Canonical VIP membership Stripe offer (Ana Fernández).
 *
 * Single source of truth for display + checkout. Keep in sync with
 * `api/lib/vipMembershipStripeDefaults.ts` (server cannot import Vite `@/`).
 *
 * Stripe Dashboard:
 *   Coupon   ana_vip_70  — Ana VIP — 70% primer mes (once)
 *   Code     ANA70
 *   Promo id promo_1TzyMyH8xCanmtKXKsOmWgAp
 *   Price    price_1TsRwOH8xCanmtKXBEW8SAea  ($29.99 / month)
 */

/** Recurring VIP Price (prod_UsCLwRCliyEnz0). */
export const VIP_STRIPE_PRICE_ID = "price_1TsRwOH8xCanmtKXBEW8SAea";

/** Promotion code object id (auto-apply on Checkout). */
export const VIP_STRIPE_PROMOTION_CODE_ID = "promo_1TzyMyH8xCanmtKXKsOmWgAp";

/** Human code shown in Stripe Dashboard. */
export const VIP_STRIPE_PROMOTION_CODE = "ANA70";

/** Coupon id (percent_off once). */
export const VIP_STRIPE_COUPON_ID = "ana_vip_70";

/** Coupon / promo display name. */
export const VIP_STRIPE_COUPON_NAME = "Ana VIP — 70% primer mes";

/** List price USD (matches Stripe Price unit_amount). */
export const VIP_LIST_PRICE_USD = 29.99;

/** List price cents. */
export const VIP_LIST_PRICE_CENTS = 2999;

/** First-month percent off (duration: once). */
export const VIP_FIRST_MONTH_DISCOUNT_PCT = 70;

/** First-month charge cents after 70% OFF. */
export function vipFirstMonthChargeCents(
  listCents: number = VIP_LIST_PRICE_CENTS,
): number {
  const list = Math.round(listCents);
  if (!Number.isFinite(list) || list <= 0) return VIP_LIST_PRICE_CENTS;
  return Math.max(
    50,
    Math.round(list * (1 - VIP_FIRST_MONTH_DISCOUNT_PCT / 100)),
  );
}

/** @deprecated Alias — same as VIP_STRIPE_PRICE_ID */
export const FALLBACK_VIP_STRIPE_PRICE_ID = VIP_STRIPE_PRICE_ID;
/** @deprecated Alias — same as VIP_STRIPE_PROMOTION_CODE_ID */
export const FALLBACK_VIP_STRIPE_PROMOTION_CODE_ID = VIP_STRIPE_PROMOTION_CODE_ID;
/** @deprecated Alias — same as VIP_LIST_PRICE_USD */
export const FALLBACK_VIP_DISPLAY_PRICE_USD = VIP_LIST_PRICE_USD;
/** @deprecated Alias — same as VIP_FIRST_MONTH_DISCOUNT_PCT */
export const FALLBACK_VIP_DISPLAY_DISCOUNT_PCT = VIP_FIRST_MONTH_DISCOUNT_PCT;
